let pagePromise;
// Shared by the initial boot and client navigation. Never imports product data eagerly.
export const loadTeamPage = () => pagePromise ||= import('../pages/seo/TjanaPengarLagetPage.jsx');
